import React from 'react';
import './PlanSelection.css';

const PlanSelection: React.FC = () => {
    return (
        <div className="plan-selection">
            <h1 className="plan-selection__title">Select Your Plan</h1>
            <div className="plan-selection__content">
                {/* Plan selection content will be added later */}
                <p>Plan selection content coming soon...</p>
            </div>
        </div>
    );
};

export default PlanSelection; 